import { Box, Button, Divider, Stack, Text, Title } from '@mantine/core';
import { useMemo } from 'react';

import { Declaration } from '@e-origin/shared';

import { declarationModalManager } from '../../../declarationModalManager';

interface AmendmentsProps {
  declaration: Declaration;
}

export const Amendments: React.FC<AmendmentsProps> = ({ declaration }) => {
  const details = declaration.customsState?.amendment?.details;
  if (!details || details.length === 0) return null;

  const lastAmendmentVersion = useMemo(() => {
    return Math.max(...details.map((d) => d.version ?? 0));
  }, [details]);

  return (
    <>
      <Divider mb="md" />
      <Stack py={20}>
        <Title order={5} fw={600}>
          AMD: Amendment confirmation received
        </Title>
        <Box pl={20}>
          <Text fw={500} size="md">
            Last Version: {lastAmendmentVersion}
          </Text>
        </Box>
        <Box pl={20}>
          <Button variant="outline" onClick={() => declarationModalManager.openAmendmentModal(declaration)}>
            View this item amendments
          </Button>
          <Button ml="md" variant="outline" onClick={() => declarationModalManager.openGroupAmendmentModal(declaration)}>
            View all items amendments
          </Button>
        </Box>
      </Stack>
    </>
  );
};
